// validators/array.ts
import { assertSchema, assertValidation, ValidationErrorBuilder } from "../errors.mjs";
import { AbstractValidator, makeValidatorFactory } from "../types.mjs";
import { getValidator } from "../utilities.mjs";
import { any } from "./any.mjs";
var AnyArrayValidator = class extends AbstractValidator {
  validate(value) {
    assertValidation(Array.isArray(value), 'Value is not an "array"');
    return [...value];
  }
};
var ArrayValidator = class extends AbstractValidator {
  maxItems;
  minItems;
  uniqueItems;
  items;
  constructor(options = {}) {
    super();
    const {
      items = any,
      maxItems = Number.POSITIVE_INFINITY,
      minItems = 0,
      uniqueItems = false
    } = options;
    assertSchema(minItems >= 0, `Constraint "minItems" (${minItems}) must be non-negative`);
    assertSchema(maxItems >= 0, `Constraint "maxItems" (${maxItems}) must be non-negative`);
    assertSchema(minItems <= maxItems, `Constraint "minItems" (${minItems}) is greater than "maxItems" (${maxItems})`);
    this.items = items;
    this.maxItems = maxItems;
    this.minItems = minItems;
    this.uniqueItems = uniqueItems;
  }
  validate(value, options) {
    assertValidation(Array.isArray(value), 'Value is not an "array"');
    assertValidation(
      value.length >= this.minItems,
      `Array must have a minimum length of ${this.minItems}`
    );
    assertValidation(
      value.length <= this.maxItems,
      `Array must have a maximum length of ${this.maxItems}`
    );
    const builder = new ValidationErrorBuilder();
    const clone = new Array(value.length);
    value.forEach((item, i) => {
      try {
        const position = value.indexOf(value[i]);
        if (position === i) {
          clone[i] = this.items.validate(item, options);
        } else if (this.uniqueItems) {
          builder.record(`Duplicate of item at index ${position}`, i);
        } else {
          clone[i] = clone[position];
        }
      } catch (error) {
        builder.record(error, i);
      }
    });
    return builder.assert(clone);
  }
};
function arrayValidatorFactory(constraints) {
  const items = constraints.items ? getValidator(constraints.items) : any;
  return new ArrayValidator({ ...constraints, items });
}
var array = makeValidatorFactory(new AnyArrayValidator(), arrayValidatorFactory);
function arrayOf(validation) {
  return new ArrayValidator({ items: getValidator(validation) });
}
export {
  AnyArrayValidator,
  ArrayValidator,
  array,
  arrayOf,
  arrayValidatorFactory
};
//# sourceMappingURL=array.mjs.map
